// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--WmojE","detail__title":"detail__title--1WcCi"};